import React from 'react';
import { ToolLoader } from '@quickenloans-tools/tool-loader';
import GenericHeroWithImage from '../../Molecules/GenericHeroWithImage/GenericHeroWithImage';
import RatesArticlesContent from '../../Molecules/RatesArticlesContent';
import { defaultAttributes, testAttributes } from './Constants';
import { calculatorEnvs } from '../../../utilities/parseHTML/parse/replacements/toCalculator/Constants';
import {
    lightBlueBackground, ratesTableWrapper,
    sectionContainer,
    mortgageTrendsCustom,
} from './scss/NewMortgageRate.module.scss';

const NewMortgageRate = () => 
{
    const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'local';
    const { hero, ratesTable } = defaultAttributes;
    return (
        <app-mortgage-rates data-testid={testAttributes.MORTGAGE_RATE_PAGE}>
            <div className="QLD_ROOT">
                <section className={`${lightBlueBackground} ${sectionContainer}`} data-testid={testAttributes.MORTGAGE_RATE_HERO_SECTION}>
                    <GenericHeroWithImage
                        title={hero.title}
                        description={hero.description}
                        image={hero.image}
                        backgroundColor={{ backgroundColor: '' }}
                    />
                </section>

                <section className={`${ratesTableWrapper} ${sectionContainer}`} data-testid={testAttributes.MORTGAGE_RATES_TABLE_CONTAINER}>
                    <ToolLoader
                        {...ratesTable}
                        eventHandler={() => 
                        {}}
                        options={{ domain: calculatorEnvs[activeEnv]?.domain }}
                    />
                </section>

                <section className={`${sectionContainer} ${mortgageTrendsCustom}`} data-testid={testAttributes.MORTGAGE_RATE_CHART_CONTAINER}>
                    <ToolLoader
                        tool="mortgage-trends"
                        options={{ domain: calculatorEnvs[activeEnv]?.domain }}
                        eventHandler={() => 
                        {}}
                    />
                </section>

                <section className={sectionContainer} data-testid={testAttributes.MORTGAGE_RATE_ARTICLES_SECTION}>
                    <div className="qld-grid">
                        <RatesArticlesContent />
                    </div>
                </section>
            </div>
        </app-mortgage-rates>
    );
};

export default NewMortgageRate; 